// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v6.30.2
// source: services/transportation/reports/freshwater.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { OffsetDateTime } from "../../../common/date_time/date_time";
import { EmptyRequest } from "../../../common/messages/messages";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "services.transportation.reports";

export interface FreshwaterDeliveryNote {
  fileId: string;
  bdnNumber: string;
  vesselName: string;
  vesselImo: string;
  date: OffsetDateTime | undefined;
  product: string;
  quantity: number;
  priorRob?: number | undefined;
  isDeleted?: boolean | undefined;
  supplierOrganisationId: string;
  locationOrganisationId: string;
}

export interface GetFreshwaterRequest {
  vesselImo: string;
}

export interface GetFreshwatersResponse {
  freshWaters: FreshwaterDeliveryNote[];
}

export interface GetUpdatedFreswatersRequest {
  vesselImo: string;
  since: string | undefined;
}

export interface GetFreshWaterDeliveryNoteRequest {
  vesselImo: string;
  fdnNumber: string;
  timestamp: string | undefined;
}

export interface GetOneFreshwaterResponse {
  data: FreshwaterDeliveryNote | undefined;
  version: number;
}

export interface UpdateFreshwaterRequest {
  data: FreshwaterDeliveryNote | undefined;
  expectedVersion: number;
}

function createBaseFreshwaterDeliveryNote(): FreshwaterDeliveryNote {
  return {
    fileId: "",
    bdnNumber: "",
    vesselName: "",
    vesselImo: "",
    date: undefined,
    product: "",
    quantity: 0,
    priorRob: undefined,
    isDeleted: undefined,
    supplierOrganisationId: "",
    locationOrganisationId: "",
  };
}

export const FreshwaterDeliveryNote: MessageFns<FreshwaterDeliveryNote> = {
  encode(message: FreshwaterDeliveryNote, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileId !== "") {
      writer.uint32(10).string(message.fileId);
    }
    if (message.bdnNumber !== "") {
      writer.uint32(18).string(message.bdnNumber);
    }
    if (message.vesselName !== "") {
      writer.uint32(26).string(message.vesselName);
    }
    if (message.vesselImo !== "") {
      writer.uint32(34).string(message.vesselImo);
    }
    if (message.date !== undefined) {
      OffsetDateTime.encode(message.date, writer.uint32(42).fork()).join();
    }
    if (message.product !== "") {
      writer.uint32(50).string(message.product);
    }
    if (message.quantity !== 0) {
      writer.uint32(57).double(message.quantity);
    }
    if (message.priorRob !== undefined) {
      writer.uint32(65).double(message.priorRob);
    }
    if (message.isDeleted !== undefined) {
      writer.uint32(72).bool(message.isDeleted);
    }
    if (message.supplierOrganisationId !== "") {
      writer.uint32(82).string(message.supplierOrganisationId);
    }
    if (message.locationOrganisationId !== "") {
      writer.uint32(90).string(message.locationOrganisationId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FreshwaterDeliveryNote {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFreshwaterDeliveryNote();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.bdnNumber = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.vesselName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.date = OffsetDateTime.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.product = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.quantity = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.priorRob = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.isDeleted = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.supplierOrganisationId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.locationOrganisationId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FreshwaterDeliveryNote {
    return {
      fileId: isSet(object.fileId) ? globalThis.String(object.fileId) : "",
      bdnNumber: isSet(object.bdnNumber) ? globalThis.String(object.bdnNumber) : "",
      vesselName: isSet(object.vesselName) ? globalThis.String(object.vesselName) : "",
      vesselImo: isSet(object.vesselImo) ? globalThis.String(object.vesselImo) : "",
      date: isSet(object.date) ? OffsetDateTime.fromJSON(object.date) : undefined,
      product: isSet(object.product) ? globalThis.String(object.product) : "",
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      priorRob: isSet(object.priorRob) ? globalThis.Number(object.priorRob) : undefined,
      isDeleted: isSet(object.isDeleted) ? globalThis.Boolean(object.isDeleted) : undefined,
      supplierOrganisationId: isSet(object.supplierOrganisationId)
        ? globalThis.String(object.supplierOrganisationId)
        : "",
      locationOrganisationId: isSet(object.locationOrganisationId)
        ? globalThis.String(object.locationOrganisationId)
        : "",
    };
  },

  toJSON(message: FreshwaterDeliveryNote): unknown {
    const obj: any = {};
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    if (message.bdnNumber !== "") {
      obj.bdnNumber = message.bdnNumber;
    }
    if (message.vesselName !== "") {
      obj.vesselName = message.vesselName;
    }
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.date !== undefined) {
      obj.date = OffsetDateTime.toJSON(message.date);
    }
    if (message.product !== "") {
      obj.product = message.product;
    }
    if (message.quantity !== 0) {
      obj.quantity = message.quantity;
    }
    if (message.priorRob !== undefined) {
      obj.priorRob = message.priorRob;
    }
    if (message.isDeleted !== undefined) {
      obj.isDeleted = message.isDeleted;
    }
    if (message.supplierOrganisationId !== "") {
      obj.supplierOrganisationId = message.supplierOrganisationId;
    }
    if (message.locationOrganisationId !== "") {
      obj.locationOrganisationId = message.locationOrganisationId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FreshwaterDeliveryNote>, I>>(base?: I): FreshwaterDeliveryNote {
    return FreshwaterDeliveryNote.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FreshwaterDeliveryNote>, I>>(object: I): FreshwaterDeliveryNote {
    const message = createBaseFreshwaterDeliveryNote();
    message.fileId = object.fileId ?? "";
    message.bdnNumber = object.bdnNumber ?? "";
    message.vesselName = object.vesselName ?? "";
    message.vesselImo = object.vesselImo ?? "";
    message.date = (object.date !== undefined && object.date !== null)
      ? OffsetDateTime.fromPartial(object.date)
      : undefined;
    message.product = object.product ?? "";
    message.quantity = object.quantity ?? 0;
    message.priorRob = object.priorRob ?? undefined;
    message.isDeleted = object.isDeleted ?? undefined;
    message.supplierOrganisationId = object.supplierOrganisationId ?? "";
    message.locationOrganisationId = object.locationOrganisationId ?? "";
    return message;
  },
};

function createBaseGetFreshwaterRequest(): GetFreshwaterRequest {
  return { vesselImo: "" };
}

export const GetFreshwaterRequest: MessageFns<GetFreshwaterRequest> = {
  encode(message: GetFreshwaterRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFreshwaterRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFreshwaterRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFreshwaterRequest {
    return { vesselImo: isSet(object.vesselImo) ? globalThis.String(object.vesselImo) : "" };
  },

  toJSON(message: GetFreshwaterRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFreshwaterRequest>, I>>(base?: I): GetFreshwaterRequest {
    return GetFreshwaterRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFreshwaterRequest>, I>>(object: I): GetFreshwaterRequest {
    const message = createBaseGetFreshwaterRequest();
    message.vesselImo = object.vesselImo ?? "";
    return message;
  },
};

function createBaseGetFreshwatersResponse(): GetFreshwatersResponse {
  return { freshWaters: [] };
}

export const GetFreshwatersResponse: MessageFns<GetFreshwatersResponse> = {
  encode(message: GetFreshwatersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.freshWaters) {
      FreshwaterDeliveryNote.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFreshwatersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFreshwatersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.freshWaters.push(FreshwaterDeliveryNote.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFreshwatersResponse {
    return {
      freshWaters: globalThis.Array.isArray(object?.freshWaters)
        ? object.freshWaters.map((e: any) => FreshwaterDeliveryNote.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetFreshwatersResponse): unknown {
    const obj: any = {};
    if (message.freshWaters?.length) {
      obj.freshWaters = message.freshWaters.map((e) => FreshwaterDeliveryNote.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFreshwatersResponse>, I>>(base?: I): GetFreshwatersResponse {
    return GetFreshwatersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFreshwatersResponse>, I>>(object: I): GetFreshwatersResponse {
    const message = createBaseGetFreshwatersResponse();
    message.freshWaters = object.freshWaters?.map((e) => FreshwaterDeliveryNote.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetUpdatedFreswatersRequest(): GetUpdatedFreswatersRequest {
  return { vesselImo: "", since: undefined };
}

export const GetUpdatedFreswatersRequest: MessageFns<GetUpdatedFreswatersRequest> = {
  encode(message: GetUpdatedFreswatersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    if (message.since !== undefined) {
      Timestamp.encode(toTimestamp(message.since), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUpdatedFreswatersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUpdatedFreswatersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.since = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUpdatedFreswatersRequest {
    return {
      vesselImo: isSet(object.vesselImo) ? globalThis.String(object.vesselImo) : "",
      since: isSet(object.since) ? globalThis.String(object.since) : undefined,
    };
  },

  toJSON(message: GetUpdatedFreswatersRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.since !== undefined) {
      obj.since = message.since;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUpdatedFreswatersRequest>, I>>(base?: I): GetUpdatedFreswatersRequest {
    return GetUpdatedFreswatersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUpdatedFreswatersRequest>, I>>(object: I): GetUpdatedFreswatersRequest {
    const message = createBaseGetUpdatedFreswatersRequest();
    message.vesselImo = object.vesselImo ?? "";
    message.since = object.since ?? undefined;
    return message;
  },
};

function createBaseGetFreshWaterDeliveryNoteRequest(): GetFreshWaterDeliveryNoteRequest {
  return { vesselImo: "", fdnNumber: "", timestamp: undefined };
}

export const GetFreshWaterDeliveryNoteRequest: MessageFns<GetFreshWaterDeliveryNoteRequest> = {
  encode(message: GetFreshWaterDeliveryNoteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    if (message.fdnNumber !== "") {
      writer.uint32(18).string(message.fdnNumber);
    }
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFreshWaterDeliveryNoteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFreshWaterDeliveryNoteRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fdnNumber = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFreshWaterDeliveryNoteRequest {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      fdnNumber: isSet(object.fdnNumber) ? globalThis.String(object.fdnNumber) : "",
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : undefined,
    };
  },

  toJSON(message: GetFreshWaterDeliveryNoteRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.fdnNumber !== "") {
      obj.fdnNumber = message.fdnNumber;
    }
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFreshWaterDeliveryNoteRequest>, I>>(
    base?: I,
  ): GetFreshWaterDeliveryNoteRequest {
    return GetFreshWaterDeliveryNoteRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFreshWaterDeliveryNoteRequest>, I>>(
    object: I,
  ): GetFreshWaterDeliveryNoteRequest {
    const message = createBaseGetFreshWaterDeliveryNoteRequest();
    message.vesselImo = object.vesselImo ?? "";
    message.fdnNumber = object.fdnNumber ?? "";
    message.timestamp = object.timestamp ?? undefined;
    return message;
  },
};

function createBaseGetOneFreshwaterResponse(): GetOneFreshwaterResponse {
  return { data: undefined, version: 0 };
}

export const GetOneFreshwaterResponse: MessageFns<GetOneFreshwaterResponse> = {
  encode(message: GetOneFreshwaterResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      FreshwaterDeliveryNote.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.version !== 0) {
      writer.uint32(16).int64(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOneFreshwaterResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOneFreshwaterResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = FreshwaterDeliveryNote.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.version = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOneFreshwaterResponse {
    return {
      data: isSet(object.data) ? FreshwaterDeliveryNote.fromJSON(object.data) : undefined,
      version: isSet(object.version) ? globalThis.Number(object.version) : 0,
    };
  },

  toJSON(message: GetOneFreshwaterResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = FreshwaterDeliveryNote.toJSON(message.data);
    }
    if (message.version !== 0) {
      obj.version = Math.round(message.version);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOneFreshwaterResponse>, I>>(base?: I): GetOneFreshwaterResponse {
    return GetOneFreshwaterResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOneFreshwaterResponse>, I>>(object: I): GetOneFreshwaterResponse {
    const message = createBaseGetOneFreshwaterResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? FreshwaterDeliveryNote.fromPartial(object.data)
      : undefined;
    message.version = object.version ?? 0;
    return message;
  },
};

function createBaseUpdateFreshwaterRequest(): UpdateFreshwaterRequest {
  return { data: undefined, expectedVersion: 0 };
}

export const UpdateFreshwaterRequest: MessageFns<UpdateFreshwaterRequest> = {
  encode(message: UpdateFreshwaterRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      FreshwaterDeliveryNote.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.expectedVersion !== 0) {
      writer.uint32(16).int64(message.expectedVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFreshwaterRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFreshwaterRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = FreshwaterDeliveryNote.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.expectedVersion = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFreshwaterRequest {
    return {
      data: isSet(object.data) ? FreshwaterDeliveryNote.fromJSON(object.data) : undefined,
      expectedVersion: isSet(object.expectedVersion)
        ? globalThis.Number(object.expectedVersion)
        : isSet(object.expected_version)
        ? globalThis.Number(object.expected_version)
        : 0,
    };
  },

  toJSON(message: UpdateFreshwaterRequest): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = FreshwaterDeliveryNote.toJSON(message.data);
    }
    if (message.expectedVersion !== 0) {
      obj.expectedVersion = Math.round(message.expectedVersion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateFreshwaterRequest>, I>>(base?: I): UpdateFreshwaterRequest {
    return UpdateFreshwaterRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateFreshwaterRequest>, I>>(object: I): UpdateFreshwaterRequest {
    const message = createBaseUpdateFreshwaterRequest();
    message.data = (object.data !== undefined && object.data !== null)
      ? FreshwaterDeliveryNote.fromPartial(object.data)
      : undefined;
    message.expectedVersion = object.expectedVersion ?? 0;
    return message;
  },
};

export interface FreshwaterService {
  addFreshwaterDeliveryNote(
    request: DeepPartial<FreshwaterDeliveryNote>,
    metadata?: grpc.Metadata,
  ): Promise<GetOneFreshwaterResponse>;
  updateFreshwaterDeliveryNote(
    request: DeepPartial<UpdateFreshwaterRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOneFreshwaterResponse>;
  getOneFreshWaterDeliveryNote(
    request: DeepPartial<GetFreshWaterDeliveryNoteRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOneFreshwaterResponse>;
  getFreshwaters(request: DeepPartial<GetFreshwaterRequest>, metadata?: grpc.Metadata): Promise<GetFreshwatersResponse>;
  getUpdatedFreshwaters(
    request: DeepPartial<GetUpdatedFreswatersRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetFreshwatersResponse>;
  getAllFreshwaters(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetFreshwatersResponse>;
}

export class FreshwaterServiceClientImpl implements FreshwaterService {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.addFreshwaterDeliveryNote = this.addFreshwaterDeliveryNote.bind(this);
    this.updateFreshwaterDeliveryNote = this.updateFreshwaterDeliveryNote.bind(this);
    this.getOneFreshWaterDeliveryNote = this.getOneFreshWaterDeliveryNote.bind(this);
    this.getFreshwaters = this.getFreshwaters.bind(this);
    this.getUpdatedFreshwaters = this.getUpdatedFreshwaters.bind(this);
    this.getAllFreshwaters = this.getAllFreshwaters.bind(this);
  }

  addFreshwaterDeliveryNote(
    request: DeepPartial<FreshwaterDeliveryNote>,
    metadata?: grpc.Metadata,
  ): Promise<GetOneFreshwaterResponse> {
    return this.rpc.unary(
      FreshwaterServiceAddFreshwaterDeliveryNoteDesc,
      FreshwaterDeliveryNote.fromPartial(request),
      metadata,
    );
  }

  updateFreshwaterDeliveryNote(
    request: DeepPartial<UpdateFreshwaterRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOneFreshwaterResponse> {
    return this.rpc.unary(
      FreshwaterServiceUpdateFreshwaterDeliveryNoteDesc,
      UpdateFreshwaterRequest.fromPartial(request),
      metadata,
    );
  }

  getOneFreshWaterDeliveryNote(
    request: DeepPartial<GetFreshWaterDeliveryNoteRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOneFreshwaterResponse> {
    return this.rpc.unary(
      FreshwaterServiceGetOneFreshWaterDeliveryNoteDesc,
      GetFreshWaterDeliveryNoteRequest.fromPartial(request),
      metadata,
    );
  }

  getFreshwaters(
    request: DeepPartial<GetFreshwaterRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetFreshwatersResponse> {
    return this.rpc.unary(FreshwaterServiceGetFreshwatersDesc, GetFreshwaterRequest.fromPartial(request), metadata);
  }

  getUpdatedFreshwaters(
    request: DeepPartial<GetUpdatedFreswatersRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetFreshwatersResponse> {
    return this.rpc.unary(
      FreshwaterServiceGetUpdatedFreshwatersDesc,
      GetUpdatedFreswatersRequest.fromPartial(request),
      metadata,
    );
  }

  getAllFreshwaters(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetFreshwatersResponse> {
    return this.rpc.unary(FreshwaterServiceGetAllFreshwatersDesc, EmptyRequest.fromPartial(request), metadata);
  }
}

export const FreshwaterServiceDesc = { serviceName: "services.transportation.reports.FreshwaterService" };

export const FreshwaterServiceAddFreshwaterDeliveryNoteDesc: UnaryMethodDefinitionish = {
  methodName: "AddFreshwaterDeliveryNote",
  service: FreshwaterServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return FreshwaterDeliveryNote.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetOneFreshwaterResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const FreshwaterServiceUpdateFreshwaterDeliveryNoteDesc: UnaryMethodDefinitionish = {
  methodName: "UpdateFreshwaterDeliveryNote",
  service: FreshwaterServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateFreshwaterRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetOneFreshwaterResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const FreshwaterServiceGetOneFreshWaterDeliveryNoteDesc: UnaryMethodDefinitionish = {
  methodName: "GetOneFreshWaterDeliveryNote",
  service: FreshwaterServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetFreshWaterDeliveryNoteRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetOneFreshwaterResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const FreshwaterServiceGetFreshwatersDesc: UnaryMethodDefinitionish = {
  methodName: "GetFreshwaters",
  service: FreshwaterServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetFreshwaterRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetFreshwatersResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const FreshwaterServiceGetUpdatedFreshwatersDesc: UnaryMethodDefinitionish = {
  methodName: "GetUpdatedFreshwaters",
  service: FreshwaterServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetUpdatedFreswatersRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetFreshwatersResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const FreshwaterServiceGetAllFreshwatersDesc: UnaryMethodDefinitionish = {
  methodName: "GetAllFreshwaters",
  service: FreshwaterServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetFreshwatersResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: function (response) {
          if (response.status === grpc.Code.OK) {
            resolve(response.message!.toObject());
          } else {
            const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
            reject(err);
          }
        },
      });
    });
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
